export default "__VITE_ASSET__DT_BM8k$__"